'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@7f-ui/components/button/button';
import { Modal } from '@7f-ui/components/modal/modal';
import { StickyFooter } from '@7f-ui/components/sticky-footer';
import { useToast } from '@7f-ui/components/toast/toast-provider';
import { useMediaState } from '@7f-ui/hooks/use-media-state';
import type { CartItemAccommodationFragment } from '@data-access/lib/gql/cart/documents';
import type { AccommodationConfig } from '@feat/feat-accommodation/booking';
import { useCartItem } from '@feat/feat-cart/item';
import { PaxModalContent } from '@feat/feat-filter/pax';
import { resetSelectedRoomRate } from '@feat/feat-room-picker/actions';
import { useSelectedRoomRate } from '@feat/feat-room-picker/store';
import type { PaxParams } from '@feat/feat-url-state/pax';
import { formatIsoDate } from '@utils/utils-format';
import { useEffect, useState } from 'react';
import type { AppAccommodationAvailableRoomResult } from '../../unterkuenfte/_components/app-accommodation-available-room';
import { AppAccommodationAvailableRoomsContainer } from '../../unterkuenfte/_components/app-accommodation-available-rooms-container';
import { AppAccommodationDateModalContent } from '../../unterkuenfte/_components/app-accommodation-date-modal-content';
type ContentName = 'Pax' | 'Date' | 'Room';
type AppCartItemAccommodationModalProps = {
  item: CartItemAccommodationFragment | null;
  onClose: VoidFunction;
};
export function AppCartItemAccommodationModal(t0) {
  const $ = _c(6);
  const {
    item,
    onClose
  } = t0;
  const t1 = !!item;
  let t2;
  if ($[0] !== item) {
    t2 = t3 => {
      const {
        onClose: closeModal
      } = t3;
      if (!item) {
        return null;
      }
      return <Slides item={item} onClose={closeModal} />;
    };
    $[0] = item;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== onClose || $[3] !== t1 || $[4] !== t2) {
    t3 = <Modal isOpen={t1} initialContent="Pax" onClose={onClose}>{t2}</Modal>;
    $[2] = onClose;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}
type SlidesProps = {
  item: CartItemAccommodationFragment;
  onClose: VoidFunction;
};
function Slides(t0) {
  const $ = _c(40);
  const {
    item,
    onClose
  } = t0;
  const toast = useToast();
  const {
    updateAccommodation
  } = useCartItem();
  const [activeContent, setActiveContent] = useState("Pax");
  const [config, setConfig] = useConfig(item);
  let t1;
  if ($[0] !== item.accommodation.id || $[1] !== item.accommodation.name) {
    t1 = {
      id: item.accommodation.id,
      name: item.accommodation.name
    };
    $[0] = item.accommodation.id;
    $[1] = item.accommodation.name;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const accommodation = t1;
  let t2;
  if ($[3] !== item.id) {
    t2 = [item.id];
    $[3] = item.id;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  useEffect(_temp2, t2);
  let t3;
  if ($[5] !== setConfig) {
    t3 = updated => {
      resetSelectedRoomRate();
      setConfig(currentConfig => ({
        ...currentConfig,
        ...updated
      }));
      setActiveContent("Date");
    };
    $[5] = setConfig;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const handlePaxSubmit = t3;
  let t4;
  if ($[7] !== setConfig) {
    t4 = updated_0 => {
      resetSelectedRoomRate();
      setConfig(updated_0);
      setActiveContent("Room");
    };
    $[7] = setConfig;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const handleDateSubmit = t4;
  let t5;
  if ($[9] !== accommodation || $[10] !== config || $[11] !== item.id || $[12] !== onClose || $[13] !== toast || $[14] !== updateAccommodation) {
    t5 = async t6 => {
      const {
        rate,
        room
      } = t6;
      if (!rate || !room || !config.from || !config.to) {
        return;
      }
      updateAccommodation({
        itemId: item.id,
        input: {
          roomId: room.id,
          rateId: rate.id,
          accommodationId: accommodation.id,
          checkin: formatIsoDate(config.from),
          checkout: formatIsoDate(config.to),
          adultCount: config.adults,
          childrenAges: config.children.filter(Boolean).map(Number)
        }
      }, {
        onSuccess: () => {
          toast({
            message: "Ihre Auswahl wurde angepasst.",
            type: "success"
          });
          resetSelectedRoomRate();
          onClose();
        }
      });
    };
    $[9] = accommodation;
    $[10] = config;
    $[11] = item.id;
    $[12] = onClose;
    $[13] = toast;
    $[14] = updateAccommodation;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  const handleRoomSubmit = t5;
  let t6;
  if ($[16] !== config || $[17] !== handlePaxSubmit || $[18] !== item.accommodation) {
    t6 = {
      name: "Pax",
      title: "Personen w\xE4hlen",
      children: <PaxModalContent onSubmit={handlePaxSubmit} accommodation={item.accommodation} initialValues={config} showRoomsPicker={false} />
    };
    $[16] = config;
    $[17] = handlePaxSubmit;
    $[18] = item.accommodation;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  let t7;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => setActiveContent("Pax");
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let t8;
  if ($[21] !== handleDateSubmit) {
    t8 = updatedConfig => handleDateSubmit(updatedConfig);
    $[21] = handleDateSubmit;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] !== config || $[24] !== item.accommodation || $[25] !== t8) {
    t9 = {
      name: "Date",
      title: "Datum w\xE4hlen",
      onBackClick: t7,
      children: <AppAccommodationDateModalContent accommodation={item.accommodation} config={config} onSubmit={t8} />
    };
    $[23] = config;
    $[24] = item.accommodation;
    $[25] = t8;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  let t10;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = () => setActiveContent("Date");
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  let t11;
  if ($[28] !== accommodation || $[29] !== config || $[30] !== handleRoomSubmit) {
    t11 = {
      name: "Room",
      title: "Zimmer w\xE4hlen",
      onBackClick: t10,
      content: <RoomModalContent accommodation={accommodation} config={config} onSubmit={handleRoomSubmit} />
    };
    $[28] = accommodation;
    $[29] = config;
    $[30] = handleRoomSubmit;
    $[31] = t11;
  } else {
    t11 = $[31];
  }
  let t12;
  if ($[32] !== t11 || $[33] !== t6 || $[34] !== t9) {
    t12 = [t6, t9, t11];
    $[32] = t11;
    $[33] = t6;
    $[34] = t9;
    $[35] = t12;
  } else {
    t12 = $[35];
  }
  let t13;
  if ($[36] !== activeContent || $[37] !== onClose || $[38] !== t12) {
    t13 = <Modal.Slides activeContent={activeContent} onClose={onClose} slides={t12} />;
    $[36] = activeContent;
    $[37] = onClose;
    $[38] = t12;
    $[39] = t13;
  } else {
    t13 = $[39];
  }
  return t13;
}
function _temp2() {
  resetSelectedRoomRate();
  return _temp;
}
function _temp() {
  resetSelectedRoomRate();
}
type RoomModalContentProps = {
  accommodation: {
    id: number;
    name: string;
  };
  config: AccommodationConfig;
  onSubmit: (result: AppAccommodationAvailableRoomResult) => Promise<void>;
};
function RoomModalContent(t0) {
  const $ = _c(14);
  const {
    accommodation,
    config,
    onSubmit
  } = t0;
  const isMobile = useMediaState("mobile");
  const {
    rate,
    room
  } = useSelectedRoomRate();
  let t1;
  if ($[0] !== onSubmit) {
    t1 = async result => {
      if (result) {
        await onSubmit(result);
      }
    };
    $[0] = onSubmit;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== accommodation || $[3] !== config || $[4] !== t1) {
    t2 = <AppAccommodationAvailableRoomsContainer accommodation={accommodation} config={config} showRoomCount={false} onSubmit={t1} />;
    $[2] = accommodation;
    $[3] = config;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== isMobile || $[7] !== onSubmit || $[8] !== rate || $[9] !== room) {
    t3 = isMobile && <StickyFooter><Button full={true} disabled={!rate || !room} onClick={() => {
        if (!rate || !room) {
          return;
        }
        onSubmit({
          rate,
          room
        });
      }}>Auswählen</Button></StickyFooter>;
    $[6] = isMobile;
    $[7] = onSubmit;
    $[8] = rate;
    $[9] = room;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== t2 || $[12] !== t3) {
    t4 = <>{t2}{t3}</>;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4;
}
function useConfig(item) {
  const $ = _c(5);
  let t0;
  if ($[0] !== item.adultCount || $[1] !== item.checkin || $[2] !== item.checkout || $[3] !== item.childrenAges) {
    t0 = () => ({
      adults: item.adultCount ?? 2,
      children: item.childrenAges ?? [],
      from: item.checkin ? new Date(item.checkin) : null,
      to: item.checkout ? new Date(item.checkout) : null
    });
    $[0] = item.adultCount;
    $[1] = item.checkin;
    $[2] = item.checkout;
    $[3] = item.childrenAges;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  return useState(t0);
}